<script>
  import {media} from 'svelte-match-media'
  import ViewSource from '../components/ViewSource.svelte'
</script>
<h2 class="title">US Programmatic Connected TV Video Ad Spending, 2019-2022</h2>
<p class="txt1">Billions and % change</p>
<div class="chart">
  {#if $media.mobile}
  <svg width="320" height="243" viewBox="0 0 320 243" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="139" width="68" height="65" class="white"/>
    <rect x="84" y="115" width="68" height="89" class="white"/>
    <path d="M168 65H236V204H168V65Z" class="white"/>
    <rect x="252" y="27" width="68" height="177" class="white"/>
    <path d="M286.5 155L202 104L118 136.5L33 60" class="red-outline" stroke-width="4"/>
    <g class="red">
      <circle cx="33" cy="60" r="5"/>
      <circle cx="118" cy="136" r="5"/>
      <circle cx="202" cy="104" r="5"/>
      <circle cx="286" cy="155" r="5"/>
    </g>
    <text class="bold white"><tspan x="20.1953" y="230.704">2019</tspan></text>
    <text class="bold white"><tspan x="15.126" y="126.704">$3.20</tspan></text>
    <text class="white"><tspan x="14.5449" y="48.669">79.0%</tspan></text>
    <text class="bold white"><tspan x="99.1328" y="104.704">$4.36</tspan></text>
    <text class="bold white"><tspan x="183.769" y="54.704">$6.67</tspan></text>
    <text class="bold white"><tspan x="267.796" y="16.704">$8.67</tspan></text>
    <text class="bold white"><tspan x="100.719" y="230.704">2020</tspan></text>
    <text class="bold white"><tspan x="186.414" y="230.704">2021</tspan></text>
    <text class="bold white"><tspan x="269.19" y="230.704">2022</tspan></text>
    <text class="black"><tspan x="98.5176" y="157.069">36.3%</tspan></text>
    <text class="black"><tspan x="182.524" y="92.069">54.4%</tspan></text>
    <text class="black"><tspan x="266.436" y="177.069">28.8%</tspan></text>
  </svg>
  <div class="line"></div>

  {:else}
    <svg width="595" height="248" viewBox="0 0 595 248" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="203.792" x2="595" y2="203.792" stroke="white"/>
      <text class="white bold large"><tspan x="60" y="236.376">2019</tspan></text>
      <text class="white bold large"><tspan x="204" y="236.376">2020</tspan></text>
      <text class="white bold large"><tspan x="351" y="236.376">2021</tspan></text>
      <text class="white bold large"><tspan x="496" y="236.376">2022</tspan></text>
      <text class="white bold large"><tspan x="56" y="127.376">$3.20</tspan></text>
      <text class="white large"><tspan x="56" y="45.336">79.0%</tspan></text>
      <text class="white bold large"><tspan x="202" y="105.376">$4.36</tspan></text>
      <text class="white bold large"><tspan x="348" y="55.376">$6.67</tspan></text>
      <text class="white bold large"><tspan x="494" y="17.376">$8.67</tspan></text>
      <text class="black large"><tspan x="201" y="158.736">36.3%</tspan></text>
      <text class="black large"><tspan x="347" y="90.736">54.4%</tspan></text>
      <text class="black large"><tspan x="493" y="177.736">28.8%</tspan></text>
      <rect x="19" y="139" width="117.959" height="65" fill="white"/>
      <rect x="165" y="115" width="117.959" height="89" fill="white"/>
      <path d="M311 65H428.959V204H311V65Z" fill="white"/>
      <rect x="456" y="27" width="117.959" height="177" fill="white"/>
      <path d="M516.072 155L369.49 104L221.776 136.5L76.3269 60" class="red-outline" stroke-width="4"/>
      <g class="red">
        <circle cx="74.6531" cy="59" r="6"/>
        <circle cx="222" cy="135.292" r="6"/>
        <circle cx="369" cy="104.292" r="6"/>
        <circle cx="513.531" cy="154" r="6"/>
      </g>
    </svg>
  {/if}
</div>
<div class="key">
  <div class="key1 item"><div class="block"></div><p class="name">Connected TV video ad spending</p></div>
  <div class="key2 item"><div class="block"></div><p class="name">% Change</p></div>
</div>
<ViewSource id="ctv_ad_spending">eMarketer</ViewSource>

<style>
  .title {
    margin: 0 0 .625rem;
  }
  .txt1 {
    margin: 0 0 .875rem;
  }
  svg {
    margin: auto;
  }
  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
  }
  .large {
    font-size: 16px;
  }
  .bold {
    font-weight: bold
  }
  .red {
    fill: var(--verizon-red)
  }
  .red-outline {
    stroke: var(--verizon-red)
  }
  .black {
    fill: black
  }
  .white {
    fill: white
  }
  .line {
    height: 1px;
    background: white;
    position: relative;
    width: 100%;
    transform: translateY(-39px);
  }
  .key {
    display: flex;
    font-weight: bold;
    font-size: 14px;
    margin: 10px -10px -10px -10px;
  }
  .key .name {
    margin: 0;
    max-width: 130px
  }
  .key .item {
    display: flex;
    margin: 10px;
  }
  .key .block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    transform: translateY(2px)
  }
  .key1 .block {
    background: white;
  }
  .key2 .block {
    background: var(--verizon-red)
  }
  @media(min-width: 768px) {
    svg {
      width: 100%;
      height: auto;
    }
    .key {
      margin-top: 24px;
    }
    .key .name {
      max-width: none;
    }
    .txt1 {
      margin: 0 0 3rem;
    }
  }
</style>